// This code has been fully generated by an AI.

import { Component, inject, signal } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { heroTrash } from '@ng-icons/heroicons/outline';
import { firstValueFrom } from 'rxjs';
import { EmployeeDataService } from '@app/core/services/employee-data.service';
import { ToastService } from '@app/core/services/toast.service';
import { prepareProfilePicture } from '@app/shared/util/prepare-profile-picture';

@Component({
  imports: [NgIcon],
  selector: 'if-profile-picture-upload',
  templateUrl: './profile-picture-upload.component.html',
  viewProviders: [provideIcons({ heroTrash })],
})
export class ProfilePictureUploadComponent {
  protected readonly employeeDataService = inject(EmployeeDataService);
  protected readonly pictureBusy = signal(false);

  private readonly toastService = inject(ToastService);

  async uploadPicture(input: HTMLInputElement): Promise<void> {
    const file = input.files?.[0];
    input.value = '';
    if (!file || this.pictureBusy()) return;
    this.pictureBusy.set(true);
    try {
      let picture: Blob;
      try {
        picture = await prepareProfilePicture(file);
      } catch (error) {
        this.toastService.error(error instanceof Error ? error.message : 'Das Profilbild konnte nicht verarbeitet werden.');
        return;
      }
      await firstValueFrom(this.employeeDataService.uploadPicture(picture));
    } catch (error) {
      // BaseApi already displays HTTP errors; unexpected failures still reach Angular's ErrorHandler.
      if (!(error instanceof HttpErrorResponse)) throw error;
    } finally {
      this.pictureBusy.set(false);
    }
  }

  async deletePicture(): Promise<void> {
    if (this.pictureBusy()) return;
    this.pictureBusy.set(true);
    try {
      await firstValueFrom(this.employeeDataService.deletePicture());
    } catch (error) {
      if (!(error instanceof HttpErrorResponse)) throw error;
    } finally {
      this.pictureBusy.set(false);
    }
  }
}
